import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';
import baseApi from '../api/baseApi';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    const defaultMiddleware = getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    });
    
    return defaultMiddleware.concat(thunk, baseApi.middleware);
  },
  devTools: process.env.NODE_ENV === 'development',
});

setupListeners(store.dispatch);

export default store;
